import type { FaireProductEntity } from "../../entity_types/product";

export const p_98d8jfkwjd: FaireProductEntity = {
  token: "p_98d8jfkwjd",
  type: "product",
  name: "Candle Care Tool Set - Wick Trimmer + Dipper",
  brandName: "Kalamazoo Candle Company",
  imageUrl:
    "https://cdn.faire.com/fastly/d16dfcd40c99e455f774af512a8e46e42b23fc9079a48db8c8a5eb29ed063afa.jpeg",
  priceDollars: 7,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/81844271e86577e4c3af10faad3301516b16515644253e615621832e24c7e3db.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
